<script>
import { trackingQueryFromRoute } from '@/pages/dashboard/trackingQuery'

export default {
  name: 'PageSubmenu',
  props: {
    links: {
      type: Array
    }
  },
  data () {
    return {
      roles: this.$store.getters.roles,
      currentRoutePath: this.$route.path
    }
  },
  computed: {
    preservedTrackingQuery () {
      return trackingQueryFromRoute(this.$route)
    }
  },
  methods: {
    linkTo (link) {
      return {
        path: link.path,
        query: link.query || this.preservedTrackingQuery
      }
    },
    linkIsActive (link) {
      if (!link || !link.path) {
        return false
      }

      if (link.activePrefix && this.$route.path.startsWith(link.activePrefix)) {
        return true
      }

      if (this.$route.path !== link.path) {
        return false
      }

      const desiredQuery = link.query || this.preservedTrackingQuery
      const currentQuery = this.$route.query || {}

      return Object.keys(desiredQuery).every(key => {
        return String(currentQuery[key] || '') === String(desiredQuery[key] || '')
      })
    }
  }
}
</script>

<template>
  <div class="bg-primary-400 px-2 flex py-4 w-full justify-between items-center flex-wrap overflow-x-auto overflow-y-visible">
    <nav class="flex gap-4">
      <!-- Current: "bg-indigo-100 text-indigo-700", Default: "text-gray-500 hover:text-gray-700" -->
      <div
        v-for="(link, key) in links"
        :key="key"
        class="flex-shrink-0"
      >
        <router-link
          v-if="link && link.roles.some(role => $store.getters.roles.includes(role))"
          :to="linkTo(link)"
          tag="a"
          :class="[
            'rounded-md px-3 py-2 text-sm font-medium transition-colors',
            linkIsActive(link)
              ? 'bg-indigo-100 text-indigo-700'
              : 'text-gray-200 hover:text-white'
          ]"
        >{{ link.label }}</router-link>
      </div>
    </nav>
    <div v-if="$slots.default" class="flex items-center gap-3 px-3">
      <slot />
    </div>
  </div>
</template>
